import { createRoot } from "react-dom/client";
import App from "./App";
import { initObservability } from "./observability/init";

initObservability();

const root = createRoot(document.getElementById("root"));
root.render(<App />);

